import { render, staticRenderFns } from "./g-fk-filter.vue?vue&type=template&id=a1c0685c&scoped=true"
import script from "./g-fk-filter.vue?vue&type=script&lang=js"
export * from "./g-fk-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c0685c",
  null
  
)

export default component.exports